module.exports = __webpack_public_path__ + "static/media/back.60b09c13.jpg";